import { createClient } from '@supabase/supabase-js'

// Wklej tutaj swoje dane z panelu Supabase
const supabaseUrl = 'https://evaqpqgcwbtyvigeflkf.supabase.co'; 
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV2YXFwcWdjd2J0eXZpZ2VmbGtmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcyNzc3MzksImV4cCI6MjA3Mjg1MzczOX0.IkGdcn1_WFeXxetGuK8f9Lc_oK_llIVSbKp7LA0_5lc';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL and Anon Key are required.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);